import logo from './logo.svg';
import './Assets/Style/Style.css';
import AppRoutes from './AppRoutes/AppRoutes';
import FullNameLogoIcon from './Assets/Images/FullWhiteNameLogo.png'
// import FullLogoIcon from './Assets/Images/WhiteLogoIcon.png'
import FullLogoIcon from "./Assets/Images/FullLogoIcon.png";
import FullLogoIcon2 from "./Assets/Images/Fulllogodarktheme.png";
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';


function App() {

  const location = useLocation()
  const theme = useTheme();
  const [showLogo, setShowLogo] = useState(window.innerWidth >= 1080 && location.pathname == "/");
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const [completeAnimation, setCompleteAnimation] = useState(false)
  useEffect(() => {
    if (window.innerWidth >= 1080) {
      const timer = setTimeout(() => {
        setShowLogo(false);
      }, 3500);

      return () => clearTimeout(timer);
    } else {
      // mobile → directly hide logo
      setShowLogo(false);
    }

  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setCompleteAnimation(true)
    }, 4000);

    return () => clearTimeout(timer);
  }, [])

  return (
    <div className="App">
      <Toaster position="top-right" />
      {!isMobile && !completeAnimation && (location.pathname == "/") && (<Box component={'img'} className="animated-logo animated-logo2" src={FullLogoIcon2}></Box>)}

      {!showLogo && (
        <Box className='bg-color'>
          <AppRoutes />
        </Box>
      )}
    </div>
  );

  // return (
  //   <div className="App">
  //     {(showLogo && location.pathname == "/") ? (

  //       <Box className='new-animated-logo m-0 p-0 d-flex align-items-center' gap={5}>
  //         <Box component={'img'} maxHeight={'120px'} src={FullLogoIcon}></Box>
  //         <Box component={'img'} className='swipe-logo' maxHeight={'110px'} src={FullNameLogoIcon}></Box>
  //       </Box>
  //     ) : (
  //       <Box className='bg-color'>
  //         <AppRoutes />
  //       </Box>
  //     )}
  //   </div>
  // );
}



export default App;
